import React from 'react';
import { Button, Modal, Checkbox, Form } from 'antd';
import { useSelector } from "react-redux";
import EmailField from '../SharedComponents/FormComponents/EmailField';
import { CloseIcon, NotifiedRight } from '../../assets/icons';
import FloatingLabel from '../FloatingLabel/FloatingLabel';

const NotifyMeModal = React.forwardRef((props, ref) => {
  const { open, setOpen, email, setEmail, setNewsLetterChecked, newsLetterChecked, handleNotifyMe } = props
  const loading = useSelector((state) => state.notifyMeSlice.loading);
  return (
    <Modal
      className='ant-modal--footer-shadow'
      open={open}
      onCancel={() => {
        setOpen(false);
        setEmail('');
        setNewsLetterChecked(false);
        ref?.current?.resetFields();
      }}
      width={524}
      closeIcon={<CloseIcon />}
      centered
      footer={null}
    >
      <div className='modal-inner'>
        <NotifiedRight color='#C04F0F' />
        <p className='mt-16 subhead-1 mb-16'>Get notified when the Realbricks Market opens up to the public.</p>
        <p className='text-left mb-24'>We’ll send you an email when properties become available to be traded on the Realbricks Market.</p>
        <Form
          name='signup-form'
          className='details-form'
          onFinish={handleNotifyMe}
          autoComplete='off'
          ref={ref}
          form={ref?.current}
          onValuesChange={(changedValues) => setEmail(changedValues?.email)}
        >
          <FloatingLabel label='Email' name='email' inputValue={ref?.current?.getFieldValue('email') || email}>
            <EmailField email={email} setEmail={(value) => ref?.current?.setFieldsValue({ email: value })} />
          </FloatingLabel>
          <p className='text-left mt-36 mb-48'>
            <Checkbox checked={newsLetterChecked} onClick={() => setNewsLetterChecked(!newsLetterChecked)}>
              Sign up for the Realbricks newsletter
            </Checkbox>
          </p>
          <Form.Item className="mb-0" shouldUpdate>
            {() => (
              <Button
                type='primary'
                htmlType='submit'
                className='w-100'
                loading={loading}
                disabled={
                  !ref?.current?.isFieldsTouched(true) ||
                  ref?.current?.getFieldsError().filter(({ errors }) => errors.length)
                    .length > 0
                }
              >
                Save
              </Button>
            )}
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
});

export default NotifyMeModal;
